<template>
  <section id="main-content">
    <v-layout
      row
      wrap>
      <v-flex
        xs12
        md5
        xl5
        class="masterDropdown">
        <v-btn @click="goBacktoAdminList">Go back to Admin List</v-btn>
      </v-flex>

      <v-flex
        xs12
        sm12
        md7
        xl7
        style="text-align:right">
        <Can
          I="manage"
          a="reports">
          <HelperCsvDownload
            :isDisabled="disableAWSExtractbtn()"
            :data="awsExtractData"
            :dl-label="'aws Extract'"
            style="display: inline "
            :title="'AWS-Extract-Template'"
            @csv-download-success="awsExtract"
          />
        </Can>
        <Can
          i="write"
          a="oppreg-admin">
          <v-btn
            :disabled="disableAPNbtn()"
            @click="submitOpportunityToAPN"><v-icon
              small
              title="Submit Opportunity to APN"
              class="mr-2"
              color="primary"
              flat>cloud_upload</v-icon>Submit To APN</v-btn>
        </Can>
        <v-btn @click="showLogs()"><v-icon
          small
          title="Changelogs"
          class="mr-2"
          color="primary"
          flat>history</v-icon>View Changelogs</v-btn>
      </v-flex>

    </v-layout>
    <div style="color:#fff">{{ newWorkload.wlqa.Project_Id }}</div>
    <v-toolbar
      color="blue"
      dark
      tabs>
      <template v-slot:extension>
        <v-tabs
          v-model="currentItem"
          color="transparent"
          fixed-tabs
          slider-color="orange">
          <v-tab
            v-for="item in items"
            :key="item"
            :href="'#tab-' + item">{{ item }}</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="currentItem">
      <v-card flat>
        <v-card-text>
          <v-tab-item
            :value="'tab-Opportunity'"
            class="tab-content">
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    readonly
                    v-model="workload.opportunity.Opportunity_Id"
                    label="Opportunity Id (readonly)"
                    placeholder="Opportunity Id"
                  />
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.SFDC_Oppty_Name"
                    label="Salesforce Opportunity Name Id"
                    placeholder="Salesforce Opportunity Name Id"
                  />
                </v-flex>
                <v-flex
                  md4
                  xl4>
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.SFDC_Sales_Stage"
                    label="Salesforce Sales Stage"
                    placeholder="Salesforce Sales Stage"
                  />
                </v-flex>

                <v-flex
                  md3
                  xl3
                  >
                  <v-menu
                    v-model="oppSignDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="!isRecordView"
                        v-model="oppSignDate"
                        label="Sign Date"
                        v-on="on"
                        readonly
                      />
                    </template>
                    <v-date-picker
                      v-model="oppSignDate"
                      :disabled="!isRecordView"
                      attach
                      no-title
                      scrollable
                      @input="oppSignDateMenu = false"/>
                  </v-menu>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.OpportunityTotalValueUSD"
                    label="Opportunity Total Value USD"
                    placeholder="Opportunity Total Value USD"
                    type="number"
                  />
                </v-flex>
                <v-flex
                  md4
                  xl4>
                  <!-- <v-text-field
                    v-model="workload.opportunity.ESRegion"
                    label="Region"
                    placeholder ="Region"
                    readonly/>
                  -->
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.ESRegion"
                    label="Region"
                    placeholder="Region"
                  />
                <!-- <v-select
                  v-model= "workload.opportunity.ESRegion"
                  :items="regions"
                  item-text="region"
                  label="Region"
                  placeholder="Region"
                /> -->
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.Customer_Name"
                    label="Customer Name"
                    placeholder="Customer Name"
                  />
                  <!-- <v-autocomplete
                    v-model="workload.opportunity.Customer_Name"
                    :items="customers"
                    :search-input.sync="search"
                    item-text="Customer_Name"
                    label="Customer Name"
                    data-vv-name="Customer_Id"
                  /> -->
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <!-- <v-text-field
                    v-model="workload.opportunity.Country"
                    label="Country"
                    placeholder="Country"
                    readonly/> -->
                  <v-select
                    :disabled="!isRecordView"
                    :items="countries"
                    v-model="workload.opportunity.Country"
                    item-text="country"
                    item-value="country"
                    label="Country"
                    placeholder="Country"
                  />
                </v-flex>
                <v-flex
                  md4
                  xl4>
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.PrimaryESPracticeName"
                    label="Primary ES Practice Name"
                    placeholder="Primary ES Practice Name"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <v-textarea
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.OpportunityDescription"
                    label="Opportunity Description"
                    placeholder="Opportunity Description"
                    name="input-7-4"
                    
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.OpportunityStatus"
                    label="Opportunity Status"
                    placeholder="Opportunity Status"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.IndustryVertical"
                    label="Industry Vertical"
                    placeholder="Industry Vertical"
                  />
                </v-flex>
                <v-flex
                  v-if="workload.opportunity.IndustryVertical === 'Other'"
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.IndustryVerticalOther"
                    label="Industry Vertical Other"
                    placeholder="Industry Vertical Other"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.ContractLength"
                    label="Contract Length"
                    placeholder="Contract Length"
                    type="number"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.AWS_ACE_ID"
                    label="AWS ACE ID"
                    placeholder="AWS ACE ID"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.Owner_Email"
                    label="SF Opp Owner Email"
                    placeholder="SF Opp Owner Email"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3
                  class="">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.Owner_Name"
                    label="SF Opp Owner Name"
                    placeholder="SF Opp Owner Name"
                  />
                </v-flex>
                <!-- <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <v-btn
                    :disabled="formIsValid"
                    color="warning"
                    @click="UpdateOppNumber()">Update</v-btn>
                </v-flex> -->
              </v-layout>
              <v-layout>
                <v-flex
                  md3
                  xl3>
                  <v-checkbox
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.Global_Registered"
                    color="orange"
                    true-value="Yes"
                    false-value="No"
                    label="Global Registered"
                  />
                </v-flex>
                <v-flex
                  md3
                  xl3>
                  <v-checkbox
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.Is_Archived"
                    color="orange"
                    true-value="Yes"
                    false-value="No"
                    label="Archive"
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                column
                align-center>
                <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <Can
                    i="write"
                    a="oppreg-admin">
                    <v-btn
                      :loading="false"
                      class="opp-btn"
                      color="warning"
                      @click="onUpdateOpportunity">Update Opportunity</v-btn>
                  </Can>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item
            :value="'tab-Account'"
            class="tab-content">
            <v-container fluid>
              <v-layout
                row
                wrap>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.account.Customer_URL"
                    label="Customer URL"
                    placeholder="Customer URL"/>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.account.Customer_Address"
                    label="Customer Address"
                    placeholder="Customer Address"/>
                </v-flex>
                <v-flex
                  md4
                  xl3
                >
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.account.Customer_City"
                    label="Customer City"
                    placeholder="Customer City"/>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.account.Customer_State"
                    label="Customer State"
                    placeholder="Customer State"/>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.account.Customer_PC"
                    label="Customer PC"/>
                </v-flex>

              </v-layout>
              <v-layout
                row
                column
                align-center>
                <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <Can
                    i="write"
                    a="oppreg-admin">
                    <v-btn
                      :loading="false"
                      class="opp-btn"
                      color="warning"
                      @click="onUpdateAccount">Update Account</v-btn>
                  </Can>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item
            :value="'tab-Requestor'"
            class="tab-content">
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  md5
                  xl5
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.requestor.Requestor_First_Name"
                    label="Requestor First Name"
                    placeholder="Requestor First Name"
                    readonly/>
                </v-flex>
                <v-flex
                  md5
                  xl5>

                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.requestor.Requestor_Last_Name"
                    label="Requestor Last Name"
                    placeholder="Requestor Last Name"
                    readonly/>
                </v-flex>
                <v-flex
                  md5
                  xl5
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.requestor.Requestor_Phone"
                    label="Phone Number"
                    placeholder="Phone Number"
                    readonly/>
                </v-flex>

                <v-flex
                  md5
                  xl5>
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.requestor.Requestor_Email"
                    label="Email"
                    placeholder="Email"
                    readonly/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item
            :value="'tab-Contact'"
            class="tab-content">
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  md2
                  xl2
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.contact.Contact_Title"
                    label="Contact Title"
                    placeholder="Contact Title"/>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.contact.Contact_First_Name"
                    label="Contact First Name"
                    placeholder="Contact First Name"/>
                </v-flex>
                <v-flex
                  md5
                  xl5 >
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.contact.Contact_Last_Name"
                    label="Contact Last Name"
                    placeholder="Contact Last Name"/>
                </v-flex>
                <v-flex
                  md2
                  xl2
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.contact.Contact_Phone"
                    label="Contact Phone"
                    placeholder="Contact Phone"/>
                </v-flex>
                <v-flex
                  md4
                  xl4
                  class="mr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.contact.Contact_Email"
                    label="Contact Email"
                    placeholder="Contact Email"/>
                </v-flex>
                <v-flex
                  md5
                  xl5>
                  <v-text-field
                    v-model="workloadContactFullName"
                    disabled
                    label="Contact Fullname"
                    placeholder="Contact Fullname"/>
                </v-flex>
              </v-layout>
              <v-layout
                row
                column
                align-center>
                <v-flex
                  xs12
                  sm12
                  md12
                  xl12>
                  <Can
                    i="write"
                    a="oppreg-admin">
                    <v-btn
                      :loading="false"
                      class="opp-btn"
                      color="warning"
                      @click="onUpdateContact">Update Contact</v-btn>
                  </Can>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item
            :value="'tab-Questionnaire'"
            class="tab-content">
 

            <formAdminOppregNewQuestionnaire v-if="newWorkload.oppproject.Q1 != 'None' && newWorkload.oppproject.Q1"/>
            <formAdminOppregOldQuestionnaire v-else-if="newWorkload.oppproject.Legacy === 'Y'"/>
            <formAdminOppregQuestionnaire v-else-if="newWorkload.oppproject.Legacy === 'N'" />
          </v-tab-item>
        </v-card-text>
      </v-card>
    </v-tabs-items>

    <div class="info-wrapper">
      <div 
      style="margin: 10px 0px; padding: 15px 25px; background-color: #FFCFCC; border-radius: 4px;font-size:14px"
      v-if="checkLegacyWorkloadStatusType"> 
        <v-icon class="mr-1" color="#FF584C" small>mdi-alert-circle</v-icon>
        <span><span style="font-weight:500">Heads Up! </span>Please take note that there is discrepancy between set Workload Status and Workload Type. This may affect the calculation of the Account type in creation of onboarding account. If this is the case,  the value of Account type will be based on the set Workload Status .</span>
      </div>
      <div 
      style="margin: 10px 0px; padding: 15px 25px; background-color: #FFCFCC; border-radius: 4px;font-size:14px"
      v-if="checkNonLegacyWorkloadStatusType"> 
        <v-icon class="mr-1" color="#FF584C" small>mdi-alert-circle</v-icon>
        <span><span style="font-weight:500">Heads Up! </span>Please take note that there is discrepancy between set Workload Status and Workload Type. This may affect the calculation of the Account type in creation of onboarding account. If this is the case,  the value of Account type will be based on the set Workload Status .</span>
      </div>
      <div
        class="aws-extract"
        style="background-color:#fff;margin-bottom:0;padding:0; height:50px; font-weight: 500;"
      >
        <v-container fluid>
          <v-layout
            row
            wrap>
            <v-flex
              md12
              xl12>
              <v-checkbox
                :disabled="workload.workloadType === 'Transfer' || !isRecordView"
                v-model="exportAll"
                label="Include in AWS Template Extract for Approval"
                @change="toggleExtract()"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-btn @click="workloadInfo = true; sendEmail = false; documents = false">Workload Information</v-btn>
      <v-btn
        @click="workloadInfo = false; sendEmail = true; documents = false">Send an Email</v-btn>

      <v-btn
        :disabled="!isAwsInfoExist "
        @click="workloadInfo = false; sendEmail = false; documents = true">Documents</v-btn>

      <div>

        <section
          v-if="workloadInfo == true"
          class="workload-info">
          <div class="header">
            <h4>
              <v-icon>mdi-information</v-icon>Workload Information
            </h4>
          </div>
          <div
            class="content">
            <v-container fluid>
              <v-layout
                row
                wrap>
                <v-flex
                  v-if="this.newWorkload.oppproject.Workload_type === 'DONTKNOW'"
                  md12
                  xl5
                  mb2
                  class="note">
                  <p>Please note that this Opportunity has a Workload type of “DONTKNOW”. Please update the Discount Qualification section in the Galaxy Opportunity Registration accordingly.</p>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  md6
                  xl5
                  class="pr-2">
                  <v-select
                    :disabled="!isRecordView"
                    :items="filterOppregStatus"
                    v-model="workload.aws.OppReg_Status"
                    class="oppstat"
                    label="Workload Status"
                    placeholder="Select a Workload Status"
                    @change="wokloadStatusChanged = true"
                    attach
                  />
                </v-flex>
                <v-flex
                  sm12
                  md6
                  xl6>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="2"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"

                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="awsDateApproved"
                        readonly
                        label="Date Approved/Disqualified"
                        v-on="on"/>
                    </template>
                    <v-date-picker
                      :disabled="!isRecordView"
                      v-model="awsDateApproved"
                      attach
                      no-title
                      scrollable>
                      <v-spacer/>
                      <v-btn
                        flat
                        color="primary"
                        @click="menu = false">Cancel</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="wokloadStatusChanged"
                row>
                <v-checkbox
                  :disabled="!isRecordView"
                  v-model="notifyAboutStatusChange"
                  class="mt-0"
                  label="Notify About Status Update?"
                  @change="toggleNotifyStatusChange"
                />
              </v-layout>

              <v-layout
                row
                wrap>
                <!-- <v-flex
                  md3
                  class="pr-2">
                  <v-text-field
                    ref="oppNumberField"
                    @focus="oppNumberisFocus = true"
                    @blur="oppNumberisFocus = false"
                    v-model.trim="workload.opportunity.Opportunity_Number"
                    :error="workload.opportunityNumberExistError"
                    :error-messages="workload.opportunityNumberExistErrorMessages"
                    :success="workload.opportunityNumberExistSuccess"
                    :success-messages="workload.opportunityNumberExistSuccessMessages"
                    :loading="workload.opportunityNumberExistLoading"
                    label="ACE Opportunity Number"
                    placeholder="ACE Opportunity Number"
                    @change="checkIfOpportunityNumberIsAvailable"/>
                </v-flex> -->
                <v-flex
                  md4
                  class="pr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.aws.AWS_SalesRep_Name"
                    placeholder="AWS SALES REP NAME"
                    label="AWS Sales Rep Name"
                  />
                </v-flex>
                <v-flex
                  md4
                  class="pr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.aws.AWS_SalesRep_eMail"
                    placeholder="AWS SALES REP Email"
                    label="AWS Sales Rep Email"
                  />
                </v-flex>
                <v-flex
                  md4>
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.opportunity.OpportunityStatus"
                    placeholder="SFDC STATUS"
                    label="SFDC Status"
                    readonly
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12>
                  <v-textarea
                    :disabled="!isRecordView"
                    v-model="workload.aws.AWS_Notes"
                    :value="''"
                    label="AWS Notes"
                    name="input-7-4"
                    placeholder="AWS NOTES"
                  />
                </v-flex>
                <v-flex
                  md6
                  xl5
                  class="pr-2">
                  <v-text-field
                    :disabled="!isRecordView"
                    v-model="workload.aws.Non_DXC_Account_No"
                    placeholder=""
                    label="Non DXC Account No"
                  />
                </v-flex>
                <v-flex
                  md6
                  xl5
                  class="pr-2">
                  <v-menu
                    :disabled="!isRecordView"
                    v-model="dates.Non_DXC_Launch_Date"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="!isRecordView"
                        v-model="workload.aws.Non_DXC_Launch_Date"
                        readonly
                        label="Non DXC Launch Date"
                        v-on="on"
                        append-icon="mdi-close"
                        @click:append="clearNonDXCLaunchDate"
                      />
                    </template>
                    <v-date-picker
                      :disabled="!isRecordView"
                      v-model="dateOnboarded"
                      @input="updateNonDXCLaunchDate"/>
                  </v-menu>
                </v-flex>
                
              <v-flex md6 xl5 class="pr-2">
                <v-text-field
                  :disabled="!isRecordView"
                  v-model="workload.aws.DXC_Account_No"
                  placeholder=""
                  label="DXC Account No"
                />
              </v-flex>
              <v-flex md6 xl5 class="pr-2">
                <v-menu
                  :disabled="!isRecordView"
                  v-model="dates.DXC_Launch_Date"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :disabled="!isRecordView"
                      v-model="workload.aws.DXC_Launch_Date"
                      readonly
                      label="DXC Launch Date"
                      v-on="on"
                      append-icon="mdi-close"
                      @click:append="clearDXCLaunchDate"
                    />
                  </template>
                  <v-date-picker
                    :disabled="!isRecordView"
                    v-model="dxcLaunchDate"
                    @input="updateDXCLaunchDate"
                  />
                </v-menu>
              </v-flex>
              </v-layout>

              <v-flex>
                <Can
                  i="write"
                  a="oppreg-admin">
                  <v-btn
                    :disabled="formIsValid || oppNumberisFocus"
                    color="warning"
                    @click="handleSubmit()">Save</v-btn>
                </Can>
              </v-flex>
            </v-container>
          </div>
        </section>

        <section
          v-if="sendEmail == true"
          class="send-an-email">
          <div class="header">
            <h4>
              <v-icon>mdi-email</v-icon>Send an Email
            </h4>
          </div>
          <div class="content px-5 py-5">
            <!-- <v-layout>
              <v-flex md12>
                <v-checkbox
                  v-model="emailReceiver"
                  value="submitter"
                  color="orange"
                  label="Email to Submitter"
                  hide-details
                  class="d-inline-block mr-5"
                />
                <v-checkbox
                  v-model="emailReceiver"
                  value="other"
                  color="orange"
                  label="Email to: "
                  hide-details
                  class="d-inline-block mr-2"
                />

                <v-text-field
                  class="d-inline-block"
                  v-model="otherContact"
                  label=""
                  aria-placeholder="Other contacts"
                  solo
                />
              </v-flex>
            </v-layout> -->
            <v-layout row wrap>
              <v-flex md12>
                <label for="">Email to Submitter</label>
              </v-flex>
              <v-flex md12>
                <v-radio-group
                  :disabled="!isRecordView"
                  v-model="email_template"
                  row >
                  <v-radio
                    label="AWS Reg Acceptance"
                    value="aws-reg-acceptance"/>
                  <v-radio
                    label="SFDC not tagged"
                    value="sfdc-not-tagged"/>
                  <v-radio
                    label="Consent to Assignment CTA"
                    value="cta"/>
                  <v-radio
                    label="Discount Update"
                    value="discount-update"/>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12>
                <label for="">Email to Opp Owner</label>
              </v-flex>
              <v-flex md12>
                <v-radio-group
                  :disabled="!isRecordView"
                  v-model="email_template"
                  row >
                  <v-radio
                    label="Reg notification"
                    value="opp-owner-email"/>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <!-- <v-layout>
              <v-flex
                class="email-submit"
                xs12
                sm12
                md12
                xl12>
                <v-radio-group
                  v-model="email_template"
                  row >
                  <v-radio
                    label="Approved PPA (23%)"
                    value="approved"/>
                  <v-radio
                    label="Approved SPP (7-12%)"
                    value="approvedspp"/>
                  <v-radio
                    label="Shareshift"
                    value="disqualifiedshareshift"/>
                  <v-radio
                    label="SFDC not tagged"
                    value="incompletecompany"/>
                </v-radio-group>
              </v-flex>
            </v-layout> -->

            <v-layout column>
              <v-flex
                xs12
                sm12
                md12
                xl12>
                <v-textarea
                  :disabled="!isRecordView"
                  v-model="dialogEmail.Notes"
                  :value="''"
                  label="Notes"
                  placeholder="Notes"
                  name="input-7-4"
                />
                <v-flex>
                  <Can
                    i="write"
                    a="oppreg-admin">
                    <v-btn
                      :disabled="email_template === ''"
                      color="warning"
                      @click="reviewAnEmail()">REVIEW EMAIL</v-btn>
                  </Can>
                </v-flex>
              </v-flex>
            </v-layout>

            <!-- <v-container>
              <v-flex
                md12
                xl12>
                <v-layout column>
                  <v-flex
                    xs12
                    sm12
                    md12
                    xl12>
                    <v-textarea
                      v-model="dialogEmail.Notes"
                      :value="''"
                      label="Notes"
                      placeholder="Notes"
                      name="input-7-4"
                    />
                    <v-flex>
                      <v-btn
                        :disabled="email_template === ''"
                        color="warning"
                        @click="reviewAnEmail()">REVIEW EMAIL</v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>

              </v-flex>
            </v-container> -->

          </div>
        </section>

        <section
          v-if="documents == true"
          class="documents">
          <div class="header">
            <h4>
              <v-icon>mdi-file</v-icon>Documents
            </h4>
          </div>
          <div
            class="content"
            style="padding:15px 10px;">
            <v-container>
              <v-layout
                row
                wrap>
                <v-flex
                  md12
                  xl12
                  align-center>

                  <formSingleUploads />

                </v-flex>

                <v-flex>
                  <material-card
                    color="blue"
                    title="Upload History">
                    <v-data-table
                      :headers="uploadHeaders"
                      :items="workload.uploads"
                    >
                      <template
                        slot="headerCell"
                        slot-scope="{ header }">
                        <span
                          class="subheading font-weight-light text-success text-md-left text--darken-3"
                          v-text="header.text"
                        />
                      </template>
                      <template v-slot:items="props">
                        <td v-if="$can('manage', 'reports')" @click="downloadFiles(props.item)">
                          <a>{{ props.item.FileName }}</a>
                        </td>
                        <td>{{ props.item.Upload_TS }}</td>
                        <td>{{ props.item.Uploaded_By }}</td>
                      </template>
                    </v-data-table>
                  </material-card>
                </v-flex>

              </v-layout>
            </v-container>
          </div>
        </section>

      </div>
    </div>

  </section>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import { getAwsAPNExtractData, getNewAwsExtract, getCountries, checkActionPermission } from '@/utils/helper'

export default {
  data: () => ({
    isDownloading: false,
    downloadSuccess: false,
    workloadInfo: true,
    sendEmail: false,
    documents: false,
    exportAll: false,
    bucketUrl: process.env.VUE_APP_S3_BUCKET,
    isChecked: false,
    filterRegInExtractWorkload: false,
    email_template: '',
    dlLabel: 'aws Extract',
    breadcrumbs: [
      {
        text: ' < Go back to Oppreg Search',
        disabled: false,
        href: '/admin/oppreg-administration/admin-content'
      }
    ],
    // regions: ['APAC', 'EMEA', 'AMS'],
    industryVerticalList: ['Agriculture & Mining', 'Biotechnology', 'Business & Consumer Services','Business Serv','Communications','Computer Hardware','Computers & Electronics','Computer Software','Consumer Goods','Consumer Related','Education','Energy & Utilities','Financial Services','Gaming','Government','Government, Education & Public Services','Healthcare','Healthcare, Pharmaceuticals and Biotech','Industrial/Energy','Internet Specific','Life Sciences','Manufacturing','Media, Entertainment & Leisure','Media & Entertainment','Medical/Health','Non-Profit Organization','Other','Professional Services','Public Services','Real Estate & Construction','Retail','Retail, Wholesale & Distribution','Semiconductor/Electr','Software & Internet','Telecommunications','Transportation & Logistics','Travel & Hospitality','Wholesale & Distribution'],
    countries: getCountries(),
    currentItem: 'tab-Opportunity',
    items: [
      'Opportunity',
      'Account',
      'Requestor',
      'Contact',
      'Questionnaire'
    ],
    oppSignDateMenu: false,
    oppNumberisFocus: false,
    valid: true,
    name: '',
    email: '',
    more: [],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    oppSignDateMenu: false,
    file: '',
    rowsPerPageItems: [10, 20, 30, 40],
    wokloadStatusChanged: false,
    notifyAboutStatusChange: false,
    emailReceiver: [],
    dates: {
      Non_DXC_Launch_Date: false,
      DXC_Launch_Date: false
    }
  }),

  computed: {
    ...mapState('admin/oppregAdmin', [
      'workload',
      'allOppregData',
      'allWorkloadByOppregId',
      'uploadHeaders',
      'uploadList',
      'isExtractChecked',
      'exportWorkloads',
      'newExportWorkloads',
      'checkedWorkloads',
      'note_post'
    ]),
    ...mapState('admin/oppregAdmin', ['logsShown', 'loadingLogs', 'logHeaders', 'logRecords', 'dialogEmail', 'isAwsInfoExist', 'sendEmailStatus', 'newWorkload']),
    // ...mapState('')
    ...mapState('admin',['customers']),
    ...mapGetters('admin/oppregAdmin', ['getLogRecords']),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },

    formIsValid () {
      return this.workload.opportunityNumberExistLoading || this.workload.opportunityNumberExistError
    },

    awsDateApproved: {
      get () {
        return window.moment(this.workload.aws.AWS_Date_Approved).isValid()
          ? this.workload.aws.AWS_Date_Approved
          : null
      },
      set (date) {
        this.workload.aws.AWS_Date_Approved = date
      }
    },
    oppSignDate: {
      get () {
        return window.moment(this.workload.opportunity.SignDate).isValid()
          ? this.workload.opportunity.SignDate
          : null
      },
      set (date) {
        this.workload.opportunity.SignDate = date
      }
    },
    awsExtractData () {
      if (this.newExportWorkloads.length) {
        return getNewAwsExtract(this.newExportWorkloads, 0)
      }
    },

    checkLegacyWorkloadStatusType() {
      let oppregStatus = ''

       if (this.workload.aws.OppReg_Status === 'Approved - Tier 3 12%' || this.workload.aws.OppReg_Status === 'Approved – Tier 3 12%') {
            oppregStatus = 'SPP'
        }
       if (this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA' || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA SaaS') {
            oppregStatus = 'PPA'
        }
      
      if ( this.workload.aws.OppReg_Status === 'Approved - Tier 3 12%' 
        || this.workload.aws.OppReg_Status === 'Approved – Tier 3 12%' 
        || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA' 
        || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA SaaS'
        ){
        if (this.newWorkload.oppproject.Workload_type !== oppregStatus && this.newWorkload.oppproject.Legacy === 'Y'  ) {
            return true
          } else {
            return false
          }
      }else {
        return false
      }
      
    },
    checkNonLegacyWorkloadStatusType() {
      let oppregStatus = ''

       if (this.workload.aws.OppReg_Status === 'Approved - Tier 3 12%' || this.workload.aws.OppReg_Status === 'Approved – Tier 3 12%') {
            oppregStatus = 'SPP'
        }
       if (this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA' || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA SaaS') {
            oppregStatus = 'PPA'
        }
      
      if ( this.workload.aws.OppReg_Status === 'Approved - Tier 3 12%' 
        || this.workload.aws.OppReg_Status === 'Approved – Tier 3 12%' 
        || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA' 
        || this.workload.aws.OppReg_Status === 'Approved - Tier 1 23% - PPA SaaS'
        ){
        if ( this.workload.workloadType !== oppregStatus && this.newWorkload.oppproject.Legacy === 'N') {
            return true
          } else {
            return false
          }
      }else {
        return false
      }
    },

    filterOppregStatus(){
      let workloadStatus

      // return [

      // ]


      if(this.newWorkload.oppproject.Legacy === 'Y') {
         workloadStatus = [
          'Approved - Tier 1 23% - PPA',
          'Approved - Tier 1 23% - PPA SaaS',
          'Approved - Tier 2 - Custom EDP',
          'Approved - Tier 3 12%',
          'AWS Reg Accepted',
          'AWS Validated',
          'Disqualified - AWS forecast conflict',
          'Disqualified - Incomplete',
          'Disqualified - No AWS scope',
          'DXC Won',
          'Incomplete/Under Review',
          'On hold Glacier',
          'On hold Other',
          'On hold – No Product in SF yet',
          'Opp Owner Email Sent',
          'Opp Owner Rejected',
          'OppReg Closed',
          'Shareshift',
          'Submitted by User',
          'Submitted to AWS'
        ]
        
      } else {
        workloadStatus = [
          'Approved - Tier 1 23% - PPA',
          'Approved - Tier 1 23% - PPA SaaS',
          'Approved - Tier 2 - Custom EDP',
          'Approved - Tier 3 12%',
          'AWS Reg Accepted',
          'Disqualified - AWS forecast conflict',
          'Disqualified - Incomplete',
          'Disqualified - No AWS scope',
          'DXC Won',
          'Incomplete/Under Review',
          'Internal - Tier 1 23% - PPA',
          'On hold Glacier',
          'On hold Other',
          'On hold – No Product in SF yet',
          'Opp Owner Email Sent',
          'Opp Owner Rejected',
          'OppReg Closed',
          'Shareshift',
          'Submitted by User',
          'Submitted to AWS'
        ]
      }

      return workloadStatus
    },

    workloadContactFullName() {
      return `${this.workload.contact.Contact_Last_Name}, ${this.workload.contact.Contact_First_Name}`
    },

    dateOnboarded: {
      get: function () {
        return this.workload.aws.Non_DXC_Launch_Date !== '0000-00-00' && this.workload.aws.Non_DXC_Launch_Date !== 'None' ? this.workload.aws.Non_DXC_Launch_Date : ''
      },
      set: function (dateOnboarded) {
        this.workload.aws.Non_DXC_Launch_Date = dateOnboarded
      }
    },
    dxcLaunchDate: {
      get: function () {
        return this.workload.aws.DXC_Launch_Date !== '0000-00-00' && this.workload.aws.DXC_Launch_Date !== 'None' ? this.workload.aws.DXC_Launch_Date : ''
      },
      set: function (dxcLaunchDate) {
        this.workload.aws.DXC_Launch_Date = dxcLaunchDate
      }
    },
    isRecordView() {
      return checkActionPermission('write', 'oppreg-admin')
    },
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => {
        this[l] = false
        this.downloadSuccess = true
      }, 3000)
      this.loader = null
    }
  },
  mounted () {
    let projectId = this.$route.params.id
    
    this.$store.dispatch('admin/oppregAdmin/loadOppregProject', projectId)
    this.$store.commit('admin/oppregAdmin/clearLogs')
    // SCRIPT TO CHECK IF THE REGISTRATION ID IS SELECTED TO AWS EXTRACT
    let x = this.checkedWorkloads.filter(res => {
      return res.Project_Id == this.$route.params.id
    })
    if (x.length > 0) {
      this.exportAll = true
    }
  },
  beforeDestroy () {
    this.$store.commit('clearLogRecord')
  },
  methods: {
    ...mapActions({
      oppregformSubmit: 'admin/oppregAdmin/submitAWSForm',
      addExport: 'admin/oppregAdmin/addToExport',
      removeExport: 'admin/oppregAdmin/removeToExport',
      awstoExtract: 'admin/oppregAdmin/awsExport',
      downloadOppRegDoc: 'admin/oppregAdmin/downloadOppRegDoc',
      submitToAPN: 'admin/oppregAdmin/submitToAPN',
      // oppNumUpdate: 'admin/oppregAdmin/updateOppNumber'
    }),
    ...mapMutations({
      clearTemplates: 'admin/oppregAdmin/clearTemplates'
    }),
    initialize () {
      this.workload
    },
    // addItem (item) {
    //   const removed = this.items.splice(0, 1)
    //   this.items.push(...this.more.splice(this.more.indexOf(item), 1))
    //   this.more.push(...removed)
    //   this.$nextTick(() => {
    //     this.currentItem = 'tab-' + item
    //   })
    // },
    updateDXCLaunchDate(date) {
      this.workload.aws.DXC_Launch_Date = date;
    },
    clearDXCLaunchDate() {
      this.workload.aws.DXC_Launch_Date = ''; // Clears the date field
    },
    updateNonDXCLaunchDate(date) {
      this.workload.aws.Non_DXC_Launch_Date = date;
    },
    clearNonDXCLaunchDate() {
      this.workload.aws.Non_DXC_Launch_Date = ''; // Clears the date field
    },
    handleSubmit (item) {
      console.log('this.workload:', this.workload)
      this.oppregformSubmit(this.workload)
    },
    // UpdateOppNumber (item) {
    //   this.oppNumUpdate(this.workload)
    // },
    // checkIfOpportunityNumberIsAvailable () {
    //   this.$store.dispatch('admin/oppregAdmin/checkIfOpportunityNumberIsAvailable', this.workload.opportunity.Opportunity_Number, { root: true })
    // },

    reviewAnEmail () {
      let emailTemp = this.email_template === 'disqualifiedshareshift' && this.workload.aws.OppReg_Status === 'Shareshift' ? 'disqualifiedshareshift' : this.email_template
      this.$store.dispatch('admin/oppregAdmin/reviewEmailTemplate', emailTemp)
      this.$store.commit('admin/oppregAdmin/openDialogEmail', {
        show: true,
        sendHandler: () => {
          console.log('send handler')
          this.$store.dispatch('admin/oppregAdmin/sendEmailTemplate', emailTemp, {
            show: false
          }, { root: true })
          this.clearTemplates()
        },
        noHandler: () => {
          this.$store.commit(
            'admin/oppregAdmin/openDialogEmail',
            {
              show: false
            },
            { root: true }
          )
        },
        email_template: emailTemp
        // type: 'confirmation'
      },
      { root: true }
      )
    },
    updateNotes () {
      let postNote = this.note_post
      this.$store.dispatch('admin/oppregAdmin/postNotesTemp', this.note_post)
    },
    toggleExtract (item) {
      let isChecked = this.exportAll
      
      if (isChecked == true) {
        this.addExport(this.workload)
      } else {
        this.removeExport(this.workload)
      }
    },
    awsExtract () {
      this.exportAll = false
      this.$store.commit('admin/oppregAdmin/clearAwsExport')
      // this.awstoExtract(this.workload)
    },
    goBacktoAdminList () {
      this.$store.dispatch('admin/oppregAdmin/refreshOppRegAdminListData')
      this.$router.push({ path: '/admin/oppreg-administration/admin-content' })
    },

    // DROPZONE Methods
    sendingEvent (file, xhr, formData) {
      formData.append('paramName', 'some value or other')
    },
    s3UploadError (error) {
      // console.log(error);
    },
    s3UploadSuccess (location) {
      // console.log(location);
    },
    uploadFiles () {
      if (this.signurl) {
        this.$refs.myVueDropzone.setAWSSigningURL(this.signurl)
        this.$refs.myVueDropzone.processQueue()
      } else {
        this.$refs.urlsigner.focus()
        alert('Enter your signing URL')
      }
    },
    downloadFiles (item) {
      this.downloadOppRegDoc(item.FileName)
    },
    disableAPNbtn () {
      let disAbleBtn = true
      if (this.exportWorkloads.length) {
        disAbleBtn = false
      }
      return disAbleBtn
    },
    disableAWSExtractbtn () {
      let disAbleAWSExtractBtn = true
      if (this.exportWorkloads.length) {
        disAbleAWSExtractBtn = false
      }
      return disAbleAWSExtractBtn
    },
    submitOpportunityToAPN () {
      if (this.exportWorkloads.length) {
        
        let opportunityData = getAwsAPNExtractData(this.exportWorkloads, 1)
        this.submitToAPN(opportunityData)
      }
    },
    showLogs () {
      if (!this.logsShown) {
        // this.$store.commit('showLogs', { id: this.$route.params.id, changeFrom: null }, { root: true })
        this.$store.dispatch('showLogRecords', this.$route.params.id)
      } else {
        this.$store.commit('admin/oppregAdmin/setLogsShown', false)
      }
    },
    toggleNotifyStatusChange (notify) {
      this.workload.notifyWorkloadStatusUpdate = notify ? true : false
      
    },
    onUpdateContact () {
      this.$store.dispatch('admin/oppregAdmin/updateContact', this.workload.contact)
    },
    onUpdateOpportunity () {
      this.$store.dispatch('admin/oppregAdmin/updateOpportunity', this.workload.opportunity)
    },
    onUpdateAccount () {
      this.$store.dispatch('admin/oppregAdmin/updateAccount', this.workload.account)
    }
  }
}
</script>
<style lang="scss" scoped>
#main-content {
  background: #fff;
  padding: 25px 25px;
  .aws-extract > .container {
    padding-left: 0;
    font-size: 14px;
  }

  .info-wrapper {
    border-top: 1px dotted lightgray;
    margin: 35px 0 25px 0;
    padding: 25px 0;
  }
  .info-wrapper > div {
    // background: #e8e6e6;
    // border:1px solid #e8e6e6;
    section {
      & div.header {
        background: #2196f3;
        padding: 2px 15px;
        h4 {
          color: #fff;
          font-weight: 500 !important;
          font-size: 14px !important;
        }
        .theme--light.v-icon {
          color: #fff !important;
        }
      }
      & div.content {
        border:1px solid #e8e6e6;
        padding: 15px 0;
        font-size: 14px !important ;
        label {
          font-weight: 500 !important;
        }
        label,
        .v-input,
        .theme--light.v-select .v-select__selections {
          color: #7f7f7f !important;
          font-size: 14px !important;
        }
        .v-btn .v-btn__content {
          color: #fff !important;
        }
      }
    }
    .theme--light.v-sheet {
      background-color: #ffff !important;
    }
  }
}

#main-content nav.v-toolbar {
  z-index: 1;
}
#main-content nav div.v-toolbar__content ,
.v-toolbar .v-toolbar__content{
  min-height:0 !important
}
.form-wrap {
  width: 80%;
  color: #000000;
}
.tab-content {
  // background: #e8e6e6;
  border: 1px solid #e8e6e6;
  padding: 25px 0;
}
.tab-content label {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
}

.v-toolbar .v-toolbar__content {
  padding-bottom: 0;
  min-height: 0;
  height: 0;
}

// .email-submit {
//   margin-top: 16px !important;
//   padding-top: 4px !important;
//   margin-left: 30px !important;
// }

.v-date-picker-table,
.theme--light.v-label {
  color: #000000;
}
.v-card__text {
  padding: 0 !important;
}

.v-toolbar .v-toolbar__content{
  min-height: 0 !important;
}
.note {
  background-color:#ff9800;
  border:1px solid #ff9800; 
  color: white !important;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.note p {
  margin-bottom: 0;
}
</style>